import { api } from "../helpers/apiHelperV3";
import { urls } from "./urls";

const API_BOOKMARKS = urls.data.API_BOOKMARKS();
/**
 * fetch bookmarks list - not sure if this is still used
 */
export const getBookmarkList = (): any => {
  return api
    .get(API_BOOKMARKS, {})
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * add bookmark
 */
export const addBookmark = (id: number): any => {
  const data = {
    id: id,
    navigationNodeId: id,
  };
  return api
    .post(API_BOOKMARKS, data)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * remove bookmark
 */
export const removeBookmark = (id: number): any => {
  const url = `${API_BOOKMARKS}/${id}`;
  return api
    .delete(url)
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
